import CollapsibleContainerBlock from './CollapsibleContainerBlock';

export default CollapsibleContainerBlock;
